import React, { useState } from 'react';
import {
    Box,
    VStack,
    HStack,
    IconButton,
    Text,
    Divider,
    Tooltip,
    useColorModeValue
} from '@chakra-ui/react';
import { FaUsers, FaHome, FaGift, FaStamp,FaPlusCircle, FaWallet, FaBars } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

const AdminNav = () => {
    const [isCollapsed, setCollapsed] = useState(false);
    const location = useLocation();
    
    const bgColor = useColorModeValue("gray.50", "gray.900");
    const hoverBgColor = useColorModeValue("teal.100", "teal.700");
    const activeBgColor = useColorModeValue("teal.200", "teal.600");
    const textColor = useColorModeValue("gray.800", "white");
    
    const toggleCollapse = () => {
        setCollapsed((prev) => !prev);
    };

    const menuItems = [
        { name: "Home", icon: FaHome, path: "/admin" },
        { name: "User Management", icon: FaUsers, path: "/admin/manage-users" },
        { name: "Reward Management", icon: FaGift, path: "/admin/manage-rewards" },
        { name: "Add Points", icon: FaPlusCircle, path: "/admin/add-points" },
        { name: "Add Stamps", icon: FaStamp, path: "/admin/add-stamps" },
        { name: "Reward Redeem", icon: FaWallet, path: "/admin/manage-reward-redeemed" },
    ];

    return (
        <Box
            width={isCollapsed ? "100px" : "260px"}
            bg={bgColor}
            p={4}
            borderRadius="md"
            //height="100vh"
            boxShadow="lg"
            transition="width 0.3s ease-in-out"
            overflow="hidden"
        >
            <HStack justify="space-between">
                <Text fontSize="lg" fontWeight="bold" color={textColor} display={isCollapsed ? "none" : "block"}>
                    Admin Panel
                </Text>
                <IconButton
                    variant="ghost"
                    colorScheme="teal"
                    icon={<FaBars />}
                    onClick={toggleCollapse}
                    aria-label="Toggle Sidebar"
                />
            </HStack>

            <Divider my={4} />

            <VStack align="start" spacing={2}>
                {menuItems.map((item) => (
                    <Tooltip key={item.path} label={item.name} placement="right" isDisabled={!isCollapsed}>
                        <Link to={item.path} style={{ width: "100%" }}>
                            <HStack
                                spacing={4}
                                p={2}
                                borderRadius="lg"
                                cursor="pointer"
                                transition="all 0.2s"
                                bg={location.pathname === item.path ? activeBgColor : "transparent"}
                                _hover={{ bg: hoverBgColor }}
                            >
                                <IconButton
                                    icon={<item.icon size="24px" />}
                                    aria-label={item.name}
                                    variant="ghost"
                                    colorScheme="teal"
                                />
                                <Text display={isCollapsed ? "none" : "block"} color={textColor}>
                                    {item.name}
                                </Text>
                            </HStack>
                        </Link>
                    </Tooltip>
                ))}
            </VStack>
        </Box>
    );
};

export default AdminNav;
